require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-179-adding-and-managing-subcontractors.json") })
        }
      }, "path---article-179-adding-and-managing-subcontractors");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-179-adding-and-managing-subcontractors!./.cache/json/article-179-adding-and-managing-subcontractors.json
// module id = 527
// module chunks = 231608221292675